import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Card,
  Box,
  Typography,
  Button,
  Divider,
  Grid,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  TextField,
  Chip,
} from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import ReviewPortalService from "../../services/review-portal-services/review-portal.service";
import {
  FORM_STATUS,
  ADVANCED_SEARCH_CRITERIA,
  ADVANCED_SEARCH_PAYLOAD_LABELS,
  ID,
} from "../utilities/Constants";
import { FormStore } from "../store/form.store";
import AdvancedSearchSummary from "./AdvancedSearchSummary";
import ExpandLessOutlined from "@material-ui/icons/ExpandLessOutlined";
import ExpandMoreOutlined from "@material-ui/icons/ExpandMoreOutlined";
import API from "../../services/http-helper.service";
import FormBuilderService from "../../services/form-builder.service";
import { Autocomplete } from "@material-ui/lab";
import FormFillerService from "../../services/review-portal-services/form-filler.service";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { Loader } from "../../components/Loader";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import { fetchRegions, fetchSites } from "../../services/api-service";
import VirtualizedListboxComponent from "../../shared/component/VirtualizedListboxComponent";
import _ from "lodash";
import { IS_CONDITIONAL_FORM_ENABLED, GEV_ID_LABEL } from "../../utility/Constant";

const styles = (theme) => ({
  container: {
    paddingTop: 20,
    paddingLeft: 20,
    paddingRight: 20,
    margin: "2%",
    position: "relative",
    minHeight: "40%",
  },
  criteriaView: { marginTop: 20, marginBottom: 40 },
  heading: { fontWeight: "bold" },
  buttonsView: { marginBottom: 10, marginTop: 10, float: "right" },
  divider: { marginBottom: "5px" },
  collapseIcon: {
    color: "#00000094",
    position: "absolute",
    top: "26px",
    right: "20px",
    border: "solid",
    borderRadius: "50%",
    borderWidth: "1px",
    borderColor: "#00000094",
    marginBottom: "5px",
  },
});

const filterFieldMappings = [
  {
    label: ADVANCED_SEARCH_CRITERIA.REGION,
    payloadLabel: ADVANCED_SEARCH_PAYLOAD_LABELS.REGION,
  },
  {
    label: ADVANCED_SEARCH_CRITERIA.WINDFARM,
    payloadLabel: ADVANCED_SEARCH_PAYLOAD_LABELS.WINDFARM,
  },
  {
    label: ADVANCED_SEARCH_CRITERIA.TURBINES,
    payloadLabel: ADVANCED_SEARCH_PAYLOAD_LABELS.TURBINES,
  },
  {
    label: ADVANCED_SEARCH_CRITERIA.FORM_NAME,
    payloadLabel: ADVANCED_SEARCH_PAYLOAD_LABELS.FORM_NAME,
  },
  {
    label: ADVANCED_SEARCH_CRITERIA.GROUP,
    payloadLabel: ADVANCED_SEARCH_PAYLOAD_LABELS.GROUP,
  },
  {
    label: ADVANCED_SEARCH_CRITERIA.SUB_GROUP,
    payloadLabel: ADVANCED_SEARCH_PAYLOAD_LABELS.SUB_GROUP,
  },
  {
    label: ADVANCED_SEARCH_CRITERIA.FORM_STATUS,
    payloadLabel: ADVANCED_SEARCH_PAYLOAD_LABELS.FORM_STATUS,
  },
  {
    label: ADVANCED_SEARCH_CRITERIA.SUBMITTED_BY,
    payloadLabel: ADVANCED_SEARCH_PAYLOAD_LABELS.SUBMITTED_BY,
  },
  {
    label: ADVANCED_SEARCH_CRITERIA.FROM_DATE,
    payloadLabel: ADVANCED_SEARCH_PAYLOAD_LABELS.FROM_DATE,
  },
  {
    label: ADVANCED_SEARCH_CRITERIA.TO_DATE,
    payloadLabel: ADVANCED_SEARCH_PAYLOAD_LABELS.TO_DATE,
  },
  {
    label: ADVANCED_SEARCH_CRITERIA.DATE_SELECTION,
    payloadLabel: ADVANCED_SEARCH_PAYLOAD_LABELS.DATE_SELECTION,
  },
  {
    label: ADVANCED_SEARCH_CRITERIA.NUMBER_OF,
    payloadLabel: ADVANCED_SEARCH_PAYLOAD_LABELS.NUMBER_OF,
  },
];

class AdvancedSearch extends React.Component {
  constructor(props) {
    super();
    this.reviewPortalService = new ReviewPortalService();
    this.formBuilderService = new FormBuilderService();
    this.formFillerService = new FormFillerService();
    this.state = {
      expanded: true,
      selectedDurationValue: "",
      searchCriteria: {},
      summaryValues: [],
      selectedWindfarmValues: [],
      selectedTurbineValues: [],
      regionOptions: [],
      siteOptions: [],
      turbineOptions: [],
      selectedFormNames: [],
      selectedSubmittedByValues: [],
      selectedFromDate: null,
      selectedToDate: null,
      selectedRecordIdValues: null,
      selectedLocationTypeValues: "",
      selectedGeIdValues: "",
      dateSelection: "",
      numberOf: "",
      formNameInputValue: "",
      advancedSearchFields: [
        {
          elements: [
            {
              type: "dropdown",
              label: ADVANCED_SEARCH_CRITERIA.REGION,
              name: "Region",
              multiple: false,
              onChange: this.onChangeRegion.bind(this),
              api: fetchRegions,
              options: "",
              menuItemValue: "siteGroupId",
              menuItemName: "siteGroupName",
            },
            {
              type: "siteautocomplete",
              label: ADVANCED_SEARCH_CRITERIA.WINDFARM,
              name: "Windfarms",
              multiple: false,
              onChange: this.onChangeWindfarm.bind(this),
              options: [],
              menuItemValue: "siteId",
              menuItemName: "siteId",
            },
            {
              type: "turbineautocomplete",
              label: ADVANCED_SEARCH_CRITERIA.TURBINES,
              name: "Turbines",
              multiple: true,
              onChange: this.onChangeTurbine.bind(this),
              options: [],
              menuItemValue: "windTurbineId",
              menuItemName: "windTurbineId",
            },
          ],
        },
        {
          elements: [
            {
              type: "autocomplete",
              label: ADVANCED_SEARCH_CRITERIA.FORM_NAME,
              name: "Form Name",
              multiple: false,
              onChange: this.onChangeFormName.bind(this),
              api: this.reviewPortalService.getAllFormNames,
              options: [],
              menuItemValue: "formName",
              menuItemName: "formName",
            },
            {
              type: "dropdown",
              label: ADVANCED_SEARCH_CRITERIA.GROUP,
              name: "Group",
              multiple: false,
              onChange: this.onChangeGroupCategory.bind(this),
              api: this.reviewPortalService.getAllGroups,
              menuItemValue: "categoryName",
              menuItemName: "categoryName",
            },
            {
              type: "dropdown",
              label: ADVANCED_SEARCH_CRITERIA.SUB_GROUP,
              name: "Sub-Group",
              multiple: false,
              onChange: this.onChangeSubGroupCategory.bind(this),
              options: [],
              menuItemValue: "categoryName",
              menuItemName: "categoryName",
            },
          ],
        },
        // Conditionally render the group with Record Id, Location Type, and GEV ID
        ...(
          IS_CONDITIONAL_FORM_ENABLED
            ? [{
                elements: [
                  {
                    type: "number",
                    label: ADVANCED_SEARCH_CRITERIA.RECORD_ID,
                    name: "Record Id",
                    onChange: this.onChangeRecordId.bind(this),
                  },
                  {
                    type: "dropdown",
                    label: ADVANCED_SEARCH_CRITERIA.LOCATION_TYPE,
                    name: "Location Type",
                    multiple: false,
                    onChange: this.onChangeLocationType.bind(this),
                    options: [
                      { value: "Pad", label: "Pad" },
                      { value: "Customer storage", label: "Customer storage" },
                      { value: "GE storage", label: "GE storage" },
                    ],
                    menuItemValue: "value",
                    menuItemName: "label",
                  },
                  {
                    type: "text",
                    label: ADVANCED_SEARCH_CRITERIA.GE_ID,
                    name: `${GEV_ID_LABEL} Search`,
                    onChange: this.onChangeGeId.bind(this),
                  },
                ],
              }]
            : []
        ),
        {
          elements: [
            {
              type: "autocomplete",
              dropdownType: "static",
              label: ADVANCED_SEARCH_CRITERIA.FORM_STATUS,
              name: "Form Status",
              multiple: false,
              onChange: this.onChangeFormStatus.bind(this),
              options: [
                FORM_STATUS.COMPLETED,
                FORM_STATUS.REJECTED,
                FORM_STATUS.INPROGRESS,
                FORM_STATUS.APPROVED,
              ],
            },
            {
              type: "autocomplete",
              label: ADVANCED_SEARCH_CRITERIA.SUBMITTED_BY,
              name: "Submitted By",
              multiple: false,
              onChange: this.onChangeSubmittedBy.bind(this),
              api: this.reviewPortalService.getAllUsers,
              options: [],
              menuItemValue: "sso",
              menuItemName: "sso",
            },
            {
              type: "dropdown",
              dropdownType: "static",
              label: "duration",
              name: "Duration",
              multiple: false,
              onChange: this.onChangeDuration.bind(this),
              options: [
                "Date Range",
                "Last N Days",
                "Last N Weeks",
                "Last N Months",
              ],
            },
            {
              type: "date",
              elements: [
                {
                  type: "datePicker",
                  label: "fromDate",
                  name: "From",
                },
                {
                  type: "datePicker",
                  label: "toDate",
                  name: "To",
                },
              ],
            },
          ],
        },
      ],
      loading: false,
      userPreferenceId: null,
    };
    this.updateState = this.updateState.bind(this);
    this.removeCriterion = this.removeCriterion.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.showSelectedDropdownValue = this.showSelectedDropdownValue.bind(this);
    this.populateDropdowns = this.populateDropdowns.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.populateSummaryValues = this.populateSummaryValues.bind(this);
    this.deleteCriteriaFromSummary = this.deleteCriteriaFromSummary.bind(this);
    this.getNameFromId = this.getNameFromId.bind(this);
    this.onDeleteSummaryValue = this.onDeleteSummaryValue.bind(this);
    this.deleteValueFromSearchCriteria =
      this.deleteValueFromSearchCriteria.bind(this);
    this.deleteValueFromSummary = this.deleteValueFromSummary.bind(this);
    this.getIdFromName = this.getIdFromName.bind(this);
    this.handleExpandOrCollapse = this.handleExpandOrCollapse.bind(this);
  }

  populateDropdowns() {
    this.setState({ loading: true });
    let arr = Array.from(this.state.advancedSearchFields);
    const promises = [];
    arr.forEach((row) => {
      row.elements.forEach((element) => {
        if (element.api) {
          const promise = element
            .api()
            .then((result) => {
              if (element.type === "turbineautocomplete") {
                element.options = result.data.sort((a, b) =>
                  a.properties.shortName.localeCompare(b.properties.shortName),
                );
              } else if (element.menuItemName === "siteGroupName") {
                const sortedRegions = result.sort((a, b) =>
                  a.siteGroupName.localeCompare(b.siteGroupName),
                );
                element.options = sortedRegions;
                this.setState({ regionOptions: sortedRegions });
              } else {
                element.options = result.data;
              }
              this.setState({ advancedSearchFields: arr });
            })
            .catch((err) => {
              return err;
            });
          promises.push(promise);
        }
      });
    });

    this.setState({ advancedSearchFields: arr });
    return Promise.all(promises);
  }

  updateAdvancedSearchField = async ({
    apiMethod,
    apiArg,
    extractData,
    elementsIndex,
    stateKey,
  }) => {
    try {
      const response = await apiMethod(apiArg);
      const data = extractData ? extractData(response) : response.data;

      if (data) {
        const arr = Array.from(this.state.advancedSearchFields);
        arr[0].elements[elementsIndex].options = data;

        const newState = {
          advancedSearchFields: arr,
        };

        if (stateKey) {
          newState[stateKey] = data;
        }

        this.setState(newState);
      }
    } catch (error) {
      console.error("Error updating advanced search field:", error);
    }
  };

  fetchSitesData = async (regionId) => {
    await this.updateAdvancedSearchField({
      apiMethod: fetchSites,
      apiArg: regionId,
      extractData: (res) =>
        res.sort((a, b) => a.properties.name.localeCompare(b.properties.name)),
      elementsIndex: 1,
      stateKey: "siteOptions",
    });
  };

  fetchTurbinesData = async (siteId) => {
    await this.updateAdvancedSearchField({
      apiMethod: this.reviewPortalService.getTurbinesForSite,
      apiArg: siteId,
      extractData: (res) => res.data.turbines,
      elementsIndex: 2,
      stateKey: "turbineOptions",
    });
  };

  componentDidMount() {
    const computeValue = async (label, value) => {
      switch (label) {
        case ADVANCED_SEARCH_CRITERIA.REGION:
          const { regionOptions } = this.state;
          const regionId = regionOptions?.filter(
            (region) => region?.siteGroupName === value,
          )[0]?.siteGroupId;
          await this.fetchSitesData(regionId);
          return [regionId];
        case ADVANCED_SEARCH_CRITERIA.WINDFARM:
          const { siteOptions } = this.state;
          const siteData = siteOptions?.filter((site) =>
            value?.some((siteName) => site?.properties?.name === siteName),
          );
          const siteIds = siteData?.map((site) => site?.siteId);
          await this.fetchTurbinesData(siteIds);
          this.setState({ selectedWindfarmValues: siteData });
          return siteData;
        case ADVANCED_SEARCH_CRITERIA.TURBINES:
          const { turbineOptions } = this.state;
          const turbineData = turbineOptions?.filter((turbine) =>
            value?.some(
              (turbineName) => turbine?.properties?.shortName === turbineName,
            ),
          );
          this.setState({ selectedTurbineValues: turbineData });
          return turbineData;
        case ADVANCED_SEARCH_CRITERIA.FORM_NAME:
          this.setState({ selectedFormNames: value });
          return value;
        case ADVANCED_SEARCH_CRITERIA.SUBMITTED_BY:
          this.setState({ selectedSubmittedByValues: value });
          return value;
        case ADVANCED_SEARCH_CRITERIA.RECORD_ID:
          this.setState({ selectedRecordIdValues: value });
          return value;
        case ADVANCED_SEARCH_CRITERIA.LOCATION_TYPE:
          this.setState({ selectedLocationTypeValues: value });
          return value;
        case ADVANCED_SEARCH_CRITERIA.GE_ID:
          this.setState({ selectedGeIdValues: value });
          return value;
        case ADVANCED_SEARCH_CRITERIA.FROM_DATE:
          this.setState({
            selectedDurationValue: "Date Range",
            selectedFromDate: value,
          });
          return value;
        case ADVANCED_SEARCH_CRITERIA.TO_DATE:
          this.setState({
            selectedDurationValue: "Date Range",
            selectedToDate: value,
          });
          return value;
        case ADVANCED_SEARCH_CRITERIA.DATE_SELECTION:
        case ADVANCED_SEARCH_CRITERIA.NUMBER_OF:
          return value;
        default:
          return value;
      }
    };

    const initializeFilters = async () => {
      if (this.props.recordId) {
        this.setState({ loading: false });
        return;
      }
      try {
        const savedFilters =
          await this.reviewPortalService.getSavedUserFilters();
        const keys = Object.keys(savedFilters);
        for (const key of keys) {
          if (key !== ID) {
            const field = filterFieldMappings?.find(
              (field) => field?.payloadLabel === key,
            );
            let computedValue;
            if (field?.label && savedFilters[key]) {
              computedValue = await computeValue(
                field?.label,
                savedFilters[key],
              );

              // Don't call updateState for DATE_SELECTION and NUMBER_OF yet
              if (
                field.label !== ADVANCED_SEARCH_CRITERIA.DATE_SELECTION &&
                field.label !== ADVANCED_SEARCH_CRITERIA.NUMBER_OF
              ) {
                this.updateState(field?.label, computedValue);
              }
            }
          } else {
            this.setState({ userPreferenceId: savedFilters[key] });
          }
        }

        // Handle duration after all filters are loaded
        const dateSelection =
          savedFilters[ADVANCED_SEARCH_PAYLOAD_LABELS.DATE_SELECTION];
        const numberOf = savedFilters[ADVANCED_SEARCH_PAYLOAD_LABELS.NUMBER_OF];

        if (dateSelection) {
          this.setState({ selectedDurationValue: dateSelection });
          let searchCriteria = { ...this.state.searchCriteria };
          searchCriteria.dateSelection = dateSelection;

          if (dateSelection === "Date Range") {
            // Convert timestamps to string format for consistency
            let formattedFromDate = null;
            let formattedToDate = null;

            if (savedFilters.fromDate) {
              formattedFromDate = new Date(savedFilters.fromDate)
                .toISOString()
                .slice(0, 10);
              searchCriteria.fromDate = formattedFromDate; // Store as string, not timestamp
              this.setState({
                selectedFromDate: new Date(savedFilters.fromDate),
              }); // Store Date object for picker
            }

            if (savedFilters.toDate) {
              formattedToDate = new Date(savedFilters.toDate)
                .toISOString()
                .slice(0, 10);
              searchCriteria.toDate = formattedToDate; // Store as string, not timestamp
              this.setState({ selectedToDate: new Date(savedFilters.toDate) }); // Store Date object for picker
            }

            this.setState({ searchCriteria }, async () => {
              await this.populateSummaryValues("duration", dateSelection);

              if (formattedFromDate) {
                await this.populateSummaryValues(
                  ADVANCED_SEARCH_CRITERIA.FROM_DATE,
                  formattedFromDate,
                );
              }

              if (formattedToDate) {
                await this.populateSummaryValues(
                  ADVANCED_SEARCH_CRITERIA.TO_DATE,
                  formattedToDate,
                );
              }
            });
          } else {
            searchCriteria.numberOf = numberOf;
            const durationType = dateSelection.split(" ")[2];
            this.setState({ searchCriteria }, () => {
              this.populateSummaryValues(
                "duration",
                `Last ${numberOf} ${durationType}`,
              );
            });
          }
        }
        this.setState({ loading: false });
      } catch (error) {
        console.error("Error initializing filters", error);
        this.setState({ loading: false });
      }
    };

    this.populateDropdowns()
      .then(() => {
        return initializeFilters();
      })
      .then(() => {
        if (this.props.recordId) {
          const recordId = String(this.props.recordId);
          this.setState(
            (prevState) => ({
              selectedRecordIdValues: recordId,
              searchCriteria: {
                [ADVANCED_SEARCH_CRITERIA.RECORD_ID]: recordId,
              },
            }),
            () => {
              this.populateSummaryValues(ADVANCED_SEARCH_CRITERIA.RECORD_ID, recordId);
              this.onSearch();
            },
          );
        }
      })
      .catch((error) => {
        console.error("Error populating advanced search dropdowns :", error);
        this.setState({ loading: false });
      });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.rowsPerPageSize !== this.props.rowsPerPageSize) {
      let searchParams = JSON.parse(JSON.stringify(this.state.searchCriteria));
      FormStore.sharedInstance().filterMyForms(
        searchParams,
        this.props.rowsPerPageSize,
      );
    }
  }

  onChangeGroupCategory = (event) => {
    const value = event.target.value;
    this.updateState(ADVANCED_SEARCH_CRITERIA.GROUP, value);
  };

  onChangeSubGroupCategory = (event) => {
    const value = event.target.value;
    if (event.target.value.length !== 0) {
      this.updateState(ADVANCED_SEARCH_CRITERIA.SUB_GROUP, value);
    } else {
      this.removeCriterion(ADVANCED_SEARCH_CRITERIA.SUB_GROUP);
    }
  };

  onChangeRegion(event) {
    if (event) {
      let arr = [];
      arr.push(event.target.value);
      this.setState({ siteOptions: [] });
      this.updateState(ADVANCED_SEARCH_CRITERIA.REGION, arr);
    }
  }

  onChangeWindfarm(event, value) {
    if (value) {
      this.setState({ selectedWindfarmValues: value });
      this.setState({ turbineOptions: [] });
      this.updateState(ADVANCED_SEARCH_CRITERIA.WINDFARM, value);
    } else {
      this.removeCriterion(ADVANCED_SEARCH_CRITERIA.WINDFARM);
    }
  }

  onChangeTurbine(event, value) {
    if (value) {
      this.setState({ selectedTurbineValues: value });
      this.updateState(ADVANCED_SEARCH_CRITERIA.TURBINES, value);
    } else {
      this.removeCriterion(ADVANCED_SEARCH_CRITERIA.TURBINES);
    }
  }

  onChangeFormName(event, value) {
    if (value) {
      this.setState({ selectedFormNames: value });
      this.updateState(ADVANCED_SEARCH_CRITERIA.FORM_NAME, value);
    } else {
      this.removeCriterion(ADVANCED_SEARCH_CRITERIA.FORM_NAME);
    }
  }

  onChangeFormStatus(event, value) {
    if (value.length !== 0) {
      this.updateState(ADVANCED_SEARCH_CRITERIA.FORM_STATUS, value);
    } else {
      this.removeCriterion(ADVANCED_SEARCH_CRITERIA.FORM_STATUS);
    }
  }

  onChangeSubmittedBy(event, value) {
    if (value) {
      this.setState({ selectedSubmittedByValues: value });
      this.updateState(ADVANCED_SEARCH_CRITERIA.SUBMITTED_BY, value);
    } else {
      this.removeCriterion(ADVANCED_SEARCH_CRITERIA.SUBMITTED_BY);
    }
  }

  onChangeRecordId(event, value) {
    // Allow only positive integer digits. Reject negatives, letters,
    // decimals, exponents and any other non-digit characters.
    const sanitized =
      typeof value === "string" ? value.replace(/[^0-9]/g, "") : "";
    if (sanitized) {
      this.setState({ selectedRecordIdValues: sanitized });
      this.updateState(ADVANCED_SEARCH_CRITERIA.RECORD_ID, sanitized);
    } else {
      this.removeCriterion(ADVANCED_SEARCH_CRITERIA.RECORD_ID);
    }
  }

  onChangeLocationType(event, value) {
    if (value) {
      this.setState({ selectedLocationTypeValues: value });
      this.updateState(ADVANCED_SEARCH_CRITERIA.LOCATION_TYPE, value);
    } else {
      this.removeCriterion(ADVANCED_SEARCH_CRITERIA.LOCATION_TYPE);
    }
  }

  onChangeGeId(event, value) {
    if (value) {
      this.setState({ selectedGeIdValues: value });
      this.updateState(ADVANCED_SEARCH_CRITERIA.GE_ID, value);
    } else {
      this.removeCriterion(ADVANCED_SEARCH_CRITERIA.GE_ID);
    }
  }

  onChangeDuration = (event) => {
    const selectedValue = event.target.value;
    let searchCriteria = { ...this.state.searchCriteria };
    this.setState({ selectedDurationValue: selectedValue });

    if (selectedValue === "Date Range") {
      delete searchCriteria.numberOf;
      delete searchCriteria.dateSelection;
      searchCriteria.fromDate = null;
      searchCriteria.toDate = null;

      this.setState(
        {
          searchCriteria,
          selectedFromDate: null,
          selectedToDate: null,
        },
        () => {
          this.updateState(
            ADVANCED_SEARCH_CRITERIA.DATE_SELECTION,
            "Date Range",
          );
        },
      );
    } else {
      this.removeCriterion(ADVANCED_SEARCH_CRITERIA.FROM_DATE, () => {
        this.removeCriterion(ADVANCED_SEARCH_CRITERIA.TO_DATE, () => {
          delete searchCriteria.fromDate;
          delete searchCriteria.toDate;

          searchCriteria.dateSelection = selectedValue;
          searchCriteria.numberOf = "";

          this.setState(
            {
              searchCriteria,
              selectedFromDate: null,
              selectedToDate: null,
            },
            () => {
              this.updateState(
                ADVANCED_SEARCH_CRITERIA.DATE_SELECTION,
                selectedValue,
              );
            },
          );
        });
      });
    }
  };

  onChangeNValue = (e) => {
    const nValue = parseInt(e.target.value, 10) || "";

    this.setState(
      (prevState) => ({
        searchCriteria: {
          ...prevState.searchCriteria,
          numberOf: nValue,
        },
      }),
      () => {
        if (nValue) {
          this.updateState(ADVANCED_SEARCH_CRITERIA.NUMBER_OF, nValue);
        }
      },
    );
  };

  onChangeFromDate(date) {
    if (date) {
      const formattedDate = new Date(date).toISOString().slice(0, 10); // "YYYY-MM-DD"
      this.setState({ selectedFromDate: formattedDate });
      this.updateState(ADVANCED_SEARCH_CRITERIA.FROM_DATE, formattedDate);
    } else {
      // deletion
      this.removeCriterion(ADVANCED_SEARCH_CRITERIA.FROM_DATE);
    }
  }

  onChangeToDate(date) {
    if (date) {
      const formattedDate = new Date(date).toISOString().slice(0, 10); // "YYYY-MM-DD"
      this.setState({ selectedToDate: formattedDate });
      this.updateState(ADVANCED_SEARCH_CRITERIA.TO_DATE, formattedDate);
    } else {
      // deletion
      this.removeCriterion(ADVANCED_SEARCH_CRITERIA.TO_DATE);
    }
  }

  updateState(attribute, value) {
    let siteId = [];
    let turbineId = [];
    const clone = Object.assign({}, this.state.searchCriteria);
    if (attribute === "siteId") {
      let siteIds = value.map((value) => value.siteId);
      siteId.push(...siteIds);
      clone[attribute] = siteId;
    } else if (attribute === "turbineId") {
      let turbineIds = value.map((value) => value.windTurbineId);
      turbineId.push(...turbineIds);
      clone[attribute] = turbineId;
    } else {
      clone[attribute] = value;
    }
    this.setState({ searchCriteria: clone }, async () => {
      if (attribute === ADVANCED_SEARCH_CRITERIA.REGION) {
        // On region change, clear child selections/options and fetch windfarms for the selected region
        const fields = Array.from(this.state.advancedSearchFields);
        fields[0].elements[2].options = [];
        this.setState({
          advancedSearchFields: fields,
          selectedTurbineValues: [],
          selectedWindfarmValues: [],
          turbineOptions: [],
        });
        await this.fetchSitesData(value[0]);
        this.removeCriterion(ADVANCED_SEARCH_CRITERIA.WINDFARM, () => {
          this.removeCriterion(ADVANCED_SEARCH_CRITERIA.TURBINES, () => {
            this.populateSummaryValues(attribute, value); // populate summary here to avoid state update clashes
          });
        });
      } else if (attribute === ADVANCED_SEARCH_CRITERIA.WINDFARM) {
        // Any windfarm change should clear turbines selection
        this.setState({ selectedTurbineValues: [] });

        // Turbines are relevant only for a single windfarm selection
        if (siteId?.length === 1) {
          await this.fetchTurbinesData(siteId);
        } else {
          const fields = Array.from(this.state.advancedSearchFields);
          fields[0].elements[2].options = [];
          this.setState({ advancedSearchFields: fields, turbineOptions: [] });
        }

        // Clear previously selected turbines from criteria/summary
        this.removeCriterion(ADVANCED_SEARCH_CRITERIA.TURBINES, () => {
          this.populateSummaryValues(attribute, value); // populate summary here to avoid state update clashes
        });
      } else if (attribute === ADVANCED_SEARCH_CRITERIA.GROUP) {
        const fields = Array.from(this.state.advancedSearchFields);
        fields[1].elements[2].options = [];
        this.setState({ advancedSearchFields: fields });

        const apiURL = this.formattedCategoryURL(
          ADVANCED_SEARCH_CRITERIA.GROUP,
          value,
        );
        let accessToken = localStorage.getItem("access_token")
          ? localStorage.getItem("access_token")
          : "";
        let config = {};
        if (accessToken && accessToken.length > 0)
          config = {
            headers: { Authorization: "Bearer " + accessToken + "" },
          };
        API.get(apiURL, config)
          .then((res) => {
            var data = res.data;
            if (data) {
              var subCategories;
              data.forEach((item) => {
                if (item.categoryName === value) {
                  subCategories = item.subCategories;
                  let arr = Array.from(this.state.advancedSearchFields);
                  arr[1].elements[2].options = subCategories;
                  this.setState({ advancedSearchFields: arr });
                }
              });
            }
          })
          .catch((err) => {
            return err;
          });
        this.removeCriterion(ADVANCED_SEARCH_CRITERIA.SUB_GROUP, () => {
          this.populateSummaryValues(attribute, value);
        });
      } else {
        this.populateSummaryValues(attribute, value);
      }
    });
  }

  formattedCategoryURL(category, name) {
    const endPoint = "category?categoryType=";
    const categoryName = "&categoryName=";
    var apiEndPoint = endPoint + category;
    if (name && name.length > 0) {
      apiEndPoint = apiEndPoint + categoryName + name;
    }
    return apiEndPoint;
  }

  removeCriterion(attribute, callback) {
    const clone = Object.assign({}, this.state.searchCriteria);
    delete clone[attribute];
    if (attribute === ADVANCED_SEARCH_CRITERIA.FROM_DATE) {
      this.setState({ selectedFromDate: null });
    }
    if (attribute === ADVANCED_SEARCH_CRITERIA.TO_DATE) {
      this.setState({ selectedToDate: null });
    }

    this.setState({ searchCriteria: clone }, () => {
      this.deleteCriteriaFromSummary(attribute, () => {
        if (typeof callback == "function") {
          callback();
        }
      });
    });
  }

  getNameFromId(attribute, id) {
    let name = "";
    this.state.advancedSearchFields.forEach((row) => {
      row.elements.forEach((field) => {
        if (field.label === attribute) {
          let selectedOption = field.options.filter(
            (option) => option.id === id,
          );
          name = selectedOption[0][field.menuItemName];
        }
      });
    });
    return name;
  }

  getIdFromName(attribute, name) {
    let id;
    this.state.advancedSearchFields.forEach((row) => {
      row.elements.forEach((field) => {
        if (field.label === attribute) {
          let selectedOption = field.options.filter(
            (option) => option[field.menuItemName] === name,
          );
          id = selectedOption[0][field.menuItemValue];
        }
      });
    });
    return id;
  }

  populateSummaryValues(attribute, value) {
    this.deleteCriteriaFromSummary(attribute, () => {
      let arr = [];
      arr = Array.from(this.state.summaryValues);

      // Special handling for duration-related attributes
      if (attribute === ADVANCED_SEARCH_CRITERIA.DATE_SELECTION) {
        // Remove any existing duration-related chips
        arr = arr.filter(
          (item) =>
            item.label !== "duration" &&
            item.label !== ADVANCED_SEARCH_CRITERIA.DATE_SELECTION &&
            item.label !== ADVANCED_SEARCH_CRITERIA.NUMBER_OF,
        );

        // Add the combined duration chip
        let summaryValue = {
          label: "duration",
          value: value,
          durationType: value.includes("Last N") ? value.split(" ")[2] : null,
        };
        arr.push(summaryValue);
      } else if (attribute === ADVANCED_SEARCH_CRITERIA.NUMBER_OF) {
        const durationIndex = arr.findIndex(
          (item) => item.label === "duration",
        );
        if (durationIndex !== -1 && value) {
          const durationType = arr[durationIndex].durationType;
          arr[durationIndex] = {
            label: "duration",
            value: `Last ${value} ${durationType}`,
            durationType: durationType,
          };
        }
      } else if (Array.isArray(value)) {
        value.forEach((selectedValue) => {
          let summaryValue = {};
          summaryValue["label"] = attribute;
          if (typeof selectedValue === "string") {
            summaryValue["value"] = selectedValue;
          } else {
            // converting ids into names
            if (attribute === "siteId") {
              summaryValue["value"] = selectedValue.properties.name;
            } else if (attribute === "turbineId") {
              summaryValue["value"] = selectedValue.properties.shortName;
            } else {
              summaryValue["value"] = this.getNameFromId(
                attribute,
                selectedValue,
              );
            }
          }
          arr.push(summaryValue);
        });
      } else {
        // string values
        let summaryValue = {};
        summaryValue["label"] = attribute;
        if (attribute === "fromDate" || attribute === "toDate") {
          summaryValue["value"] = new Date(value).toISOString().slice(0, 10);
        } else {
          summaryValue["value"] = value;
        }
        arr.push(summaryValue);
      }
      this.setState({ summaryValues: arr });
    });
  }

  deleteCriteriaFromSummary(attribute, callback) {
    let updatedSummary = this.state.summaryValues.filter(
      (criterion) => criterion.label !== attribute,
    );
    this.setState({ summaryValues: updatedSummary }, () => {
      if (typeof callback == "function") {
        callback();
      }
    });
  }

  showSelectedDropdownValue(element) {
    if (element.label !== "duration" && !element.multiple) {
      if (this.state.searchCriteria[element.label]) {
        return Array.isArray(this.state.searchCriteria[element.label])
          ? this.state.searchCriteria[element.label][0]
          : this.state.searchCriteria[element.label];
      } else {
        return "";
      }
    } else if (element.label !== "duration" && element.multiple) {
      if (this.state.searchCriteria[element.label]) {
        return this.state.searchCriteria[element.label];
      } else {
        return [];
      }
    } else {
      return this.state.selectedDurationValue;
    }
  }

  onCancel() {
    this.setState(
      {
        searchCriteria: {},
        summaryValues: [],
        selectedDurationValue: "",
        selectedWindfarmValues: [],
        selectedTurbineValues: [],
        regionOptions: [],
        siteOptions: [],
        turbineOptions: [],
        selectedFormNames: [],
        selectedSubmittedByValues: [],
        selectedFromDate: null,
        selectedToDate: null,
        selectedRecordIdValues: null,
        dateSelection: "",
        numberOf: "",
        formNameInputValue: "",
      },
      () => {
        FormStore.sharedInstance().loadMyForms();
        if (this.props.onRecordIdCleared) {
          this.props.onRecordIdCleared();
        }
      },
    );
    this.props.parentCallBack(false);
  }

  onSearch() {
    let searchParams = JSON.parse(JSON.stringify(this.state.searchCriteria));
    let formCategories = [];
    if (searchParams["Group"]) {
      formCategories.push(searchParams["Group"]);
      delete searchParams["Group"];
    }
    if (searchParams["Sub-Group"]) {
      formCategories.push(searchParams["Sub-Group"]);
      delete searchParams["Sub-Group"];
    }
    if (formCategories.length) {
      searchParams.formCategories = formCategories;
    }
    if (searchParams[ADVANCED_SEARCH_CRITERIA.GE_ID]) {
      searchParams[ADVANCED_SEARCH_CRITERIA.GE_ID] = searchParams[ADVANCED_SEARCH_CRITERIA.GE_ID].toUpperCase();
    }
    FormStore.sharedInstance()
      .filterMyForms(searchParams, this.props.rowsPerPageSize)
      .then((response) => {
        if (response.status === 200) {
          this.setState({ expanded: false });
        }
      })
      .catch((err) => {
        console.error("Search failed:", err);
      });
    if (!this.props.recordId) {
      this.computeUserFilters(searchParams);
    }
    this.props.parentCallBack(true);
  }

  computeUserFilters = async (searchParams) => {
    try {
      const payload = this.buildPayload(searchParams);
      const userFilters =
        await this.reviewPortalService.saveUserFilters(payload);
      this.setState({ userPreferenceId: userFilters?.id });
    } catch (error) {
      console.error("Failed to save user filters", error);
    }
  };

  buildPayload = (searchParams) => {
    const payload = {};
    if (this.state?.userPreferenceId) {
      payload[ID] = this.state.userPreferenceId;
    }
    const { regionOptions, siteOptions, turbineOptions } = this.state;
    Object.keys(searchParams || [])?.forEach((key) => {
      switch (key) {
        case ADVANCED_SEARCH_CRITERIA.REGION:
          const regionValue = regionOptions?.find(
            (region) => region?.siteGroupId === searchParams[key][0],
          )?.siteGroupName;
          if (regionValue)
            payload[ADVANCED_SEARCH_PAYLOAD_LABELS.REGION] = regionValue;
          break;
        case ADVANCED_SEARCH_CRITERIA.WINDFARM:
          const siteData = siteOptions?.filter((site) =>
            searchParams[key]?.some((siteId) => siteId === site?.siteId),
          );
          const siteValue = siteData?.map((site) => site?.properties?.name);
          if (siteValue?.length)
            payload[ADVANCED_SEARCH_PAYLOAD_LABELS.WINDFARM] = siteValue;
          break;
        case ADVANCED_SEARCH_CRITERIA.TURBINES:
          const turbineData = turbineOptions?.filter((turbine) =>
            searchParams[key]?.some(
              (turbineId) => turbine?.windTurbineId === turbineId,
            ),
          );
          const turbineValue = turbineData?.map(
            (turbine) => turbine?.properties?.shortName,
          );
          if (turbineValue?.length)
            payload[ADVANCED_SEARCH_PAYLOAD_LABELS.TURBINES] = turbineValue;
          break;
        case ADVANCED_SEARCH_CRITERIA.FORM_NAME:
          const formValue = searchParams[key];
          if (formValue?.length)
            payload[ADVANCED_SEARCH_PAYLOAD_LABELS.FORM_NAME] = formValue;
          break;
        case ADVANCED_SEARCH_CRITERIA.FORM_STATUS:
          const formStatus = searchParams[key];
          if (formStatus?.length)
            payload[ADVANCED_SEARCH_PAYLOAD_LABELS.FORM_STATUS] = formStatus;
          break;
        case ADVANCED_SEARCH_CRITERIA.SUBMITTED_BY:
          const userValue = searchParams[key];
          if (userValue?.length)
            payload[ADVANCED_SEARCH_PAYLOAD_LABELS.SUBMITTED_BY] = userValue;
          break;
        case ADVANCED_SEARCH_CRITERIA.FROM_DATE:
          const fromValue = searchParams[key];
          if (fromValue)
            payload[ADVANCED_SEARCH_PAYLOAD_LABELS.FROM_DATE] = new Date(
              fromValue,
            ).getTime();
          break;
        case ADVANCED_SEARCH_CRITERIA.TO_DATE:
          const toValue = searchParams[key];
          if (toValue)
            payload[ADVANCED_SEARCH_PAYLOAD_LABELS.TO_DATE] = new Date(
              toValue,
            ).getTime();
          break;
        case ADVANCED_SEARCH_CRITERIA.DATE_SELECTION:
          const dateSelection = searchParams[key];
          if (dateSelection)
            payload[ADVANCED_SEARCH_PAYLOAD_LABELS.DATE_SELECTION] =
              dateSelection;
          break;
        case ADVANCED_SEARCH_CRITERIA.NUMBER_OF:
          const numberOf = searchParams[key];
          if (numberOf)
            payload[ADVANCED_SEARCH_PAYLOAD_LABELS.NUMBER_OF] = numberOf;
          break;
        case ADVANCED_SEARCH_CRITERIA.RECORD_ID:
          const recordId = searchParams[key];
          if (recordId)
            payload[ADVANCED_SEARCH_PAYLOAD_LABELS.RECORD_ID] = recordId;
          break;
        case ADVANCED_SEARCH_CRITERIA.LOCATION_TYPE:
          const locationType = searchParams[key];
          if (locationType)
            payload[ADVANCED_SEARCH_PAYLOAD_LABELS.LOCATION_TYPE] =
              locationType;
          break;
        case ADVANCED_SEARCH_CRITERIA.GE_ID:
          const geId = searchParams[key];
          if (geId) payload[ADVANCED_SEARCH_PAYLOAD_LABELS.GE_ID] = geId.toUpperCase();
          break;
        default:
          const groupValue = searchParams["formCategories"]?.[0];
          const subGroupValue = searchParams["formCategories"]?.[1];
          if (groupValue)
            payload[ADVANCED_SEARCH_PAYLOAD_LABELS.GROUP] = groupValue;
          if (subGroupValue)
            payload[ADVANCED_SEARCH_PAYLOAD_LABELS.SUB_GROUP] = subGroupValue;
          break;
      }
    });
    return payload;
  };

  clearAutoComplete(id) {
    let autoC = document.getElementById(id);
    const ele = autoC.parentElement.getElementsByClassName(
      "MuiAutocomplete-clearIndicator",
    )[0];
    if (ele) ele.click();
  }

  onDeleteSummaryValue(selection) {
    let value = this.state.searchCriteria[selection.label];
    if (Array.isArray(value)) {
      if (
        value.length === 1 &&
        selection.label === ADVANCED_SEARCH_CRITERIA.GROUP
      ) {
        this.removeCriterion(selection.label, () => {
          //If Windfarm is deselected, delete any previously selected Turbines from underlying data  because they are not relevant anymore:

          //If Group is deselected, delete any previously selected Subgroup from underlying data  because they are not relevant anymore:
          this.removeCriterion(ADVANCED_SEARCH_CRITERIA.SUB_GROUP, () => {
            // Clear out the options of the Subgroup dropdown as well
            let arr = Array.from(this.state.advancedSearchFields);
            arr[1].elements[2].options = [];
            this.setState({ advancedSearchFields: arr });
          });
        });
      } else if (selection.label === ADVANCED_SEARCH_CRITERIA.REGION) {
        this.removeCriterion(ADVANCED_SEARCH_CRITERIA.REGION, () => {
          this.clearAutoComplete("turbineautocomplete");
          let arr = Array.from(this.state.advancedSearchFields);
          arr[0].elements[1].options = [];
          arr[0].elements[1].value = "";
          arr[0].elements[2].options = [];
          arr[0].elements[2].value = "";
          this.setState({
            advancedSearchFields: arr,
            selectedWindfarmValues: [],
            selectedTurbineValues: [],
          });
          this.removeCriterion(ADVANCED_SEARCH_CRITERIA.WINDFARM, () => {
            this.removeCriterion(ADVANCED_SEARCH_CRITERIA.TURBINES, () => {
              this.deleteValueFromSearchCriteria(selection);
            });
          });
        });
      } else if (selection.label === ADVANCED_SEARCH_CRITERIA.WINDFARM) {
        this.removeCriterion(ADVANCED_SEARCH_CRITERIA.TURBINES, () => {
          this.clearAutoComplete("turbineautocomplete");
          // Clear out the options of the Turbines dropdown as well
          let arr = Array.from(this.state.advancedSearchFields);
          let siteId = arr[0].elements[1].options.filter(
            (ele) => ele.properties.name === selection.value,
          )[0]?.siteId;
          arr[0].elements[2].options = arr[0].elements[2].options.filter(
            (option) => option.connections.siteId !== siteId,
          );
          arr[0].elements[2].value = "";
          this.setState({ advancedSearchFields: arr });
          this.deleteValueFromSearchCriteria(selection, siteId);
        });
      } else if (selection.label === ADVANCED_SEARCH_CRITERIA.TURBINES) {
        let arr = Array.from(this.state.advancedSearchFields);
        let turbineId = arr[0].elements[2].options.filter(
          (ele) => ele.properties.shortName === selection.value,
        )[0]?.windTurbineId;
        this.deleteValueFromSearchCriteria(selection, "", turbineId);
      } else {
        // multiselect dropdowns with multiple options selected
        this.deleteValueFromSearchCriteria(selection);
      }
    } else {
      // String values
      if (selection.label !== "duration") {
        if (selection.label === ADVANCED_SEARCH_CRITERIA.GROUP) {
          this.removeCriterion(selection.label, () => {
            this.removeCriterion(ADVANCED_SEARCH_CRITERIA.SUB_GROUP, () => {
              let arr = Array.from(this.state.advancedSearchFields);
              arr[1].elements[2].options = [];
              this.setState({ advancedSearchFields: arr });
            });
          });
        } else if (selection.label === ADVANCED_SEARCH_CRITERIA.RECORD_ID) {
          this.removeCriterion(selection.label, () => {
            this.setState({ selectedRecordIdValues: null });
            if (this.props.onRecordIdCleared) {
              this.props.onRecordIdCleared();
            }
          });
          return; 
        } else {
          this.removeCriterion(selection.label);
        }
      } else {
        // Duration dropdown
        this.deleteCriteriaFromSummary("duration", () => {
          this.setState({ selectedDurationValue: "" }, () => {
            // clearing out selected date range if any
            this.removeCriterion(ADVANCED_SEARCH_CRITERIA.FROM_DATE, () => {
              this.removeCriterion(ADVANCED_SEARCH_CRITERIA.TO_DATE, () => {
                this.removeCriterion(
                  ADVANCED_SEARCH_CRITERIA.DATE_SELECTION,
                  () => {
                    // numberOf key (payload key: 'numberOf')
                    this.removeCriterion(ADVANCED_SEARCH_CRITERIA.NUMBER_OF);
                  },
                );
              });
            });
          });
        });
      }
    }
    if (Object.keys(this.state.searchCriteria).length === 1) {
      FormStore.sharedInstance().loadMyForms();
      this.props.parentCallBack(false);
    }
  }

  deleteValueFromSearchCriteria(summarySelection, siteId, turbineId) {
    let obj = Object.assign({}, this.state.searchCriteria);
    let values = obj[summarySelection.label] || [];
    let updatedValues = [];
    let updatedselectedWindfarmValues = [];
    let updatedselectedTurbineValues = [];
    if (
      values &&
      values.length > 0 &&
      typeof values[0] !== typeof summarySelection.value
    ) {
      // need to convert name to id
      let selectedId = this.getIdFromName(
        summarySelection.label,
        summarySelection.value,
      );
      updatedValues = values.filter((value) => value !== selectedId);
    } else if (siteId) {
      updatedValues = values.filter((value) => value !== siteId);
      updatedselectedWindfarmValues = this.state.selectedWindfarmValues.filter(
        (value) => value.siteId !== siteId,
      );
      this.setState({ selectedWindfarmValues: updatedselectedWindfarmValues });
    } else if (turbineId) {
      updatedValues = values.filter((value) => value !== turbineId);
      updatedselectedTurbineValues = this.state.selectedTurbineValues.filter(
        (value) => value.windTurbineId !== turbineId,
      );
      this.setState({ selectedTurbineValues: updatedselectedTurbineValues });
    } else {
      updatedValues = values.filter(
        (value) => value !== summarySelection.value,
      );
    }
    if (summarySelection.label === "formName") {
      this.setState({ selectedFormNames: updatedValues });
    }
    if (summarySelection.label === "userId") {
      this.setState({ selectedSubmittedByValues: updatedValues });
    }
    obj[summarySelection.label] = updatedValues;
    this.setState({ searchCriteria: obj }, () => {
      this.deleteValueFromSummary(summarySelection.value);
    });
  }

  deleteValueFromSummary(summaryValue) {
    let updatedSummary = this.state.summaryValues.filter(
      (summaryObj) => summaryObj.value !== summaryValue,
    );
    this.setState({ summaryValues: updatedSummary });
  }

  handleExpandOrCollapse(expand) {
    this.setState({ expanded: expand });
  }

  onEnterSearch(event) {
    if (event.key === "Enter") {
      event.stopPropagation();
    }
  }

  sitefilterOptions = (options, state) => {
    const { inputValue } = state;
    return options?.filter((option) =>
      option.properties.name.toLowerCase().includes(inputValue.toLowerCase()),
    );
  };

  isApplyEnabled = () => {
    const { searchCriteria, selectedDurationValue } = this.state;
    if (!searchCriteria || Object.keys(searchCriteria).length === 0) {
      return false;
    }
    if (selectedDurationValue === "Date Range") {
      const { fromDate, toDate } = searchCriteria;
      return Boolean(fromDate && toDate);
    }
    if (selectedDurationValue?.startsWith("Last N")) {
      const n = parseInt(searchCriteria.numberOf, 10);
      return !isNaN(n) && n > 0;
    }
    return Object.values(searchCriteria).some((val) => !_.isEmpty(val));
  };

  render() {
    const { loading } = this.state;
    const { classes } = this.props;
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    return (
      <div style={{ position: "relative" }}>
        {loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Loader loading={true} position="center" />
          </div>
        )}
        <Box>
          <Grid container spacing={2}>
            <Grid item md={12} xs={12}>
              <Card className={classes.container}>
                <Typography variant="h6" className={classes.heading}>
                  ADVANCED SEARCH
                </Typography>
                <AdvancedSearchSummary
                  selectedValues={this.state.summaryValues}
                  advancedSearchFields={this.state.advancedSearchFields}
                  onDelete={this.onDeleteSummaryValue}
                />
                {this.state.expanded && (
                  <ExpandLessOutlined
                    className={classes.collapseIcon}
                    onClick={() => this.handleExpandOrCollapse(false)}
                  />
                )}
                {!this.state.expanded && (
                  <ExpandMoreOutlined
                    className={classes.collapseIcon}
                    onClick={() => this.handleExpandOrCollapse(true)}
                  />
                )}
                {
                  <div
                    style={{ display: this.state.expanded ? "block" : "none" }}
                  >
                    <Divider className={classes.divider} />
                    <Box className={classes.criteriaView}>
                      {this.state.advancedSearchFields.map((row, fIndex) => (
                        <Grid container spacing={9} key={fIndex}>
                          {row.elements.map((element, index) => (
                            <Grid item md={4} xs={12} key={index}>
                              <FormControl fullWidth variant="outlined">
                                {element.type === "dropdown" && (
                                  <div>
                                    <InputLabel htmlFor={element.label}>
                                      {element.name}
                                    </InputLabel>
                                    <Select
                                      label={element.name}
                                      style={{ width: "100%" }}
                                      onChange={(e) =>
                                        element.onChange(e, e.target.value)
                                      }
                                      multiple={element.multiple}
                                      value={this.showSelectedDropdownValue(
                                        element,
                                      )}
                                    >
                                      {element.options &&
                                        element.options.length > 0 &&
                                        element.options.map(
                                          (option, oIndex) => (
                                            <MenuItem
                                              key={oIndex}
                                              value={
                                                element.dropdownType &&
                                                element.dropdownType ===
                                                  "static"
                                                  ? option
                                                  : option[
                                                      element.menuItemValue
                                                    ]
                                              }
                                            >
                                              {element.dropdownType &&
                                              element.dropdownType === "static"
                                                ? option
                                                : option[element.menuItemName]}
                                            </MenuItem>
                                          ),
                                        )}
                                    </Select>
                                  </div>
                                )}
                                {(element.type === "text" ||
                                  element.type === "number") && (
                                  <TextField
                                    type={element.type}
                                    variant="outlined"
                                    label={element.name}
                                    value={
                                      this.state.searchCriteria[
                                        element.label
                                      ] || ""
                                    }
                                    onChange={(e) =>
                                      element.onChange(e, e.target.value)
                                    }
                                    onKeyDown={
                                      element.type === "number"
                                        ? (e) => {
                                            if (
                                              ["-", "+", "e", "E", "."].includes(
                                                e.key,
                                              )
                                            ) {
                                              e.preventDefault();
                                            }
                                          }
                                        : undefined
                                    }
                                    InputProps={
                                      element.type === "number"
                                        ? {
                                            inputProps: {
                                              min: 1,
                                              step: 1,
                                              inputMode: "numeric",
                                              pattern: "[0-9]*",
                                            },
                                          }
                                        : undefined
                                    }
                                    fullWidth
                                  />
                                )}
                                {this.state.selectedDurationValue ===
                                  "Date Range" &&
                                  element.type === "date" && (
                                    <Grid container>
                                      {element.elements &&
                                        element.elements.map(
                                          (datePicker, eeIndex) => (
                                            <Grid
                                              key={eeIndex}
                                              item
                                              md={6}
                                              xs={12}
                                            >
                                              <KeyboardDatePicker
                                                label={datePicker.name}
                                                variant="dialog"
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                InputProps={{ readOnly: true }}
                                                maxDate={
                                                  datePicker.label ===
                                                    "fromDate" &&
                                                  this.state.searchCriteria
                                                    .toDate
                                                    ? this.state.searchCriteria
                                                        .toDate
                                                    : 4102444800000
                                                } // default max date set as 2100-1-1
                                                minDate={
                                                  datePicker.label ===
                                                    "toDate" &&
                                                  this.state.searchCriteria
                                                    .fromDate
                                                    ? this.state.searchCriteria
                                                        .fromDate
                                                    : -2208988800000
                                                } // default min date set as 1900-1-1
                                                minDateMessage=""
                                                maxDateMessage=""
                                                invalidDateMessage=""
                                                inputVariant="outlined"
                                                value={
                                                  datePicker.label ===
                                                  "fromDate"
                                                    ? this.state
                                                        .selectedFromDate
                                                    : this.state.selectedToDate
                                                }
                                                onChange={
                                                  datePicker.label ===
                                                  "fromDate"
                                                    ? (date) =>
                                                        this.onChangeFromDate(
                                                          date,
                                                        )
                                                    : (date) =>
                                                        this.onChangeToDate(
                                                          date,
                                                        )
                                                }
                                                format="dd/MMM/yyyy"
                                              />
                                            </Grid>
                                          ),
                                        )}
                                    </Grid>
                                  )}
                                {[
                                  "Last N Days",
                                  "Last N Weeks",
                                  "Last N Months",
                                ].includes(this.state.selectedDurationValue) &&
                                  element.type === "date" && (
                                    <Grid container>
                                      <Grid item md={12} xs={12}>
                                        <TextField
                                          type="number"
                                          variant="outlined"
                                          label={`Enter Last N Number of ${this.state.selectedDurationValue.replace(
                                            "Last N ",
                                            "",
                                          )}`}
                                          value={
                                            this.state.searchCriteria
                                              .numberOf || ""
                                          }
                                          onChange={this.onChangeNValue}
                                          fullWidth
                                          InputProps={{
                                            inputProps: { min: 1 },
                                          }}
                                        />
                                      </Grid>
                                    </Grid>
                                  )}
                                {element.type === "autocomplete" && (
                                  <div>
                                    <Autocomplete
                                      id="autocompleteSelect"
                                      multiple
                                      ListboxComponent={
                                        VirtualizedListboxComponent
                                      }
                                      options={element?.options?.map(
                                        (option) =>
                                          element.menuItemName
                                            ? option[element.menuItemName]
                                            : option,
                                      )}
                                      disableCloseOnSelect
                                      getOptionLabel={(option) =>
                                        option ? option : ""
                                      }
                                      onChange={element.onChange}
                                      {...(element.name === "Form Name"
                                        ? {
                                            inputValue:
                                              this.state.formNameInputValue,
                                            onInputChange: (
                                              event,
                                              newInputValue,
                                              reason,
                                            ) => {
                                              if (reason !== "reset") {
                                                this.setState({
                                                  formNameInputValue:
                                                    newInputValue,
                                                });
                                              }
                                            },
                                            onBlur: () => {
                                              this.setState({
                                                formNameInputValue: "",
                                              });
                                            },
                                          }
                                        : {})}
                                      value={
                                        element.name === "Form Name"
                                          ? this.state.selectedFormNames
                                          : element.name === "Form Status"
                                            ? this.state.summaryValues
                                                ?.filter(
                                                  (data) =>
                                                    data?.label ===
                                                    "formStatus",
                                                )
                                                ?.map((data) => data?.value)
                                            : this.state
                                                .selectedSubmittedByValues
                                      }
                                      style={{ width: "100%" }}
                                      renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                          <Chip
                                            id="chip"
                                            size="small"
                                            label={option ? option : ""}
                                            {...getTagProps({ index })}
                                          />
                                        ))
                                      }
                                      renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                          <Checkbox
                                            id="checkboxIcon"
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                          />
                                          {option ? option : ""}
                                        </React.Fragment>
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          id="autocompleteID"
                                          variant="outlined"
                                          onKeyDown={this.onEnterSearch}
                                          label={element.name}
                                        />
                                      )}
                                    />
                                  </div>
                                )}
                                {element.type === "siteautocomplete" && (
                                  <div>
                                    <Autocomplete
                                      multiple
                                      id="siteautocomplete"
                                      options={element.options}
                                      onChange={element.onChange}
                                      disableCloseOnSelect
                                      value={this.state.selectedWindfarmValues}
                                      filterOptions={this.sitefilterOptions}
                                      getOptionLabel={(option) =>
                                        option?.properties?.name || ""
                                      }
                                      renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                          <Chip
                                            id="chip"
                                            size="small"
                                            label={
                                              option?.properties?.name || ""
                                            }
                                            {...getTagProps({ index })}
                                          />
                                        ))
                                      }
                                      renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                          <Checkbox
                                            id="checkboxIcon"
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                          />
                                          {option?.properties?.name || ""}
                                        </React.Fragment>
                                      )}
                                      style={{ width: "100%" }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={element.name}
                                          id="autocompleteID"
                                          variant="outlined"
                                        />
                                      )}
                                    />
                                  </div>
                                )}
                                {element.type === "turbineautocomplete" && (
                                  <div>
                                    <Autocomplete
                                      multiple
                                      disabled={
                                        this.state.selectedWindfarmValues
                                          .length > 1
                                      }
                                      id="turbineautocomplete"
                                      options={element.options}
                                      onChange={element.onChange}
                                      disableCloseOnSelect
                                      value={this.state.selectedTurbineValues}
                                      getOptionLabel={(option) =>
                                        option?.properties?.shortName || ""
                                      }
                                      renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                          <Chip
                                            id="chip"
                                            size="small"
                                            label={
                                              option?.properties?.shortName ||
                                              ""
                                            }
                                            {...getTagProps({ index })}
                                          />
                                        ))
                                      }
                                      renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                          <Checkbox
                                            id="checkboxIcon"
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                          />
                                          {option?.properties?.shortName || ""}
                                        </React.Fragment>
                                      )}
                                      style={{ width: "100%" }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={element.name}
                                          id="autocompleteID"
                                          variant="outlined"
                                        />
                                      )}
                                    />
                                  </div>
                                )}
                              </FormControl>
                            </Grid>
                          ))}
                        </Grid>
                      ))}
                    </Box>
                    <Divider className={classes.divider} />
                    <div className={classes.buttonsView}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={this.onCancel}
                      >
                        CLEAR
                      </Button>
                      <Button
                        variant="contained"
                        onClick={this.onSearch}
                        disabled={!this.isApplyEnabled()}
                      >
                        APPLY
                      </Button>
                    </div>
                  </div>
                }
              </Card>
            </Grid>
          </Grid>
        </Box>
      </div>
    );
  }
}

export { AdvancedSearch };
export default withStyles(styles)(AdvancedSearch);
